import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import { HandleError, HttpErrorHandlerService } from '../__common/http-error-handler.service';


const HTTP_OPTIONS = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

const PROJECT_API_URL = 'apiDev';

@Injectable({
  providedIn: 'root'
})

export class ApiEmailService {

  private httpPrefix = 'https://';
  private webPageDomain = 'voyjaleas.com';
  // Error handling
  private handleError: HandleError;
  cache = {};

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  sendPhpEmail(httpMethod: string,queryId: string, templateId: string, NewElement: any) {
    let apiUrl  = this.httpPrefix + this.webPageDomain + '/' + PROJECT_API_URL + '/' + httpMethod + '/email/';
    let phpFileName = 'sendEmail.php';
    let queryParam = '?queryId='+queryId;
    let queryParam1 = '&templateId='+templateId;

    apiUrl = apiUrl + phpFileName + queryParam;
    templateId?  apiUrl = apiUrl + queryParam1 : null;

    return this.http.post<any>(apiUrl, NewElement, HTTP_OPTIONS)
      .pipe(
        catchError(this.handleError('addingNewElement', NewElement))
      );
  }


  emailSender(queryId: string, templateId: string,emailTo: string) {
    let httpMethod =  'post';
    let apiUrl  = this.httpPrefix + this.webPageDomain + '/' + PROJECT_API_URL + '/' + httpMethod + '/email/sent/clients/';
    let phpFileName = 'emailSender.php';
    let queryParam = '?queryId='+queryId;
    let queryParam1 = '&templateId='+templateId;
    let queryParam2 = '&to='+emailTo;

    apiUrl = apiUrl + phpFileName + queryParam;
    templateId?  apiUrl = apiUrl + queryParam1 + queryParam2 : null;

    return this.http.post<any>(apiUrl, {}, HTTP_OPTIONS)
      .pipe(
        catchError(this.handleError('addingNewElement', {}))
      );
  }

  simpleQueryId( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string,queryParam4: string,queryParam5: string): Observable<any> {
    let phpFileName = '';
    let apiURL  = this.httpPrefix + this.webPageDomain + '/' + PROJECT_API_URL + '/get/email/';
    let queryParam = '?queryId='+queryId;
    queryParam1 !== null? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 !== null? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 !== null? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 !== null? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    queryParam5 !== null? queryParam = queryParam + '&queryParam5=' + queryParam5 : queryParam = queryParam;

    phpFileName = 'emailApi.php';
    apiURL = apiURL + phpFileName + queryParam;
    let force = false;

/*     switch(queryId){
      case 'readEmail':
      case 'lastInteractionDate':
      case 'updateAdminUserEmail':
        force = true;
        // This uses update.php logic
        //this.executeApiRequest('PUT',queryParam1,null,null,null,true);
        break;
      default:
        break;
    } */
    /* if(queryId == 'newGeneric' || queryId == 'completeInteraction'){
      force = true;
    } */
    force = true;



    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

  sendRequestToServer(url,label,force){
    if (!this.cache[label] || force) {
      this.cache[label] = this.http.get(`${url}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      );
    }
  }
}
